import { EMAIL, NAV, PHONE, PHONE_TEL, scrollToId } from "@/data/site";
import { Logo } from "./Nav";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[var(--leaf-ink)] pb-24 pt-20 text-white sm:pb-10">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <Logo light />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/75">Quality landscaping services for Pleasant View and the Greater Nashville area. Locally owned, licensed & insured.</p>
        </div>
        <div className="flex flex-col gap-3 text-sm">
          {NAV.map((n) => <button key={n.id} data-testid={`footer-link-${n.id}`} onClick={() => scrollToId(n.id)} className="w-fit text-white/80 hover:text-white">{n.label}</button>)}
        </div>
        <div className="flex flex-col gap-3 text-sm">
          <a href={PHONE_TEL} data-testid="footer-phone" className="font-display text-2xl font-black hover:text-[#bfe3bf]">{PHONE}</a>
          <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="break-all text-white/80 hover:text-white">{EMAIL}</a>
          <span className="text-white/75">Pleasant View, TN</span>
        </div>
      </div>
      <p className="pointer-events-none mt-16 select-none font-display text-[22vw] font-black leading-[0.8] text-white/[0.06] lg:text-[16rem]" aria-hidden="true">HF Landscape</p>
      <p className="mt-6 text-xs text-white/60">© {new Date().getFullYear()} HF Landscape Solutions. All rights reserved.</p>
    </div>
  </footer>
);
